const instituteManagementRoutes = (prop) => [
    {
        path: 'employee-attendance-report',
        name: prop + '.employee_attendance_report',
        meta: { auth: true },
        component: () => import('../pages/employee-attendance-report/List.vue')
    },
    {
        path: 'student-attendance-report',
        name: prop + '.student_attendance_report',
        meta: { auth: true },
        component: () => import('../pages/student-attendance-report/List.vue')
    },
    {
        path: 'individual-student-attendance-report',
        name: prop + '.individual_student_attendance-report',
        meta: { auth: true },
        component: () => import('../pages/individual-student-attendance-report/List.vue')
    },
    {
        path: 'drop-release',
        name: prop + '.drop-release',
        meta: { auth: true },
        component: () => import('../pages/student-drop-release-report/List.vue')
    },
    {
        path: 'parental-training-report',
        name: prop + '.parental-training-report',
        meta: { auth: true },
        component: () => import('../pages/parent-training-report/List.vue')
    },
    {
        path: 'yearly-admission-financial',
        name: prop + '.yearly-admission-financial',
        meta: { auth: true },
        component: () => import('../pages/student-yearly-admission-financial-report/List.vue')
    },
    {
        path: 'fullfree-self-fund-report',
        name: prop + '.fullfree_self_fund_report',
        meta: { auth: true },
        component: () => import('../pages/fullfree-self-fund-report/List.vue')
    },
    {
        path: 'registered-student-report',
        name: prop + '.registered_student_report',
        meta: { auth: true },
        component: () => import('../pages/registered-student-report/List.vue')
    },
    {
        path: 'event-report',
        name: prop + '.event_report',
        meta: { auth: true },
        component: () => import('../pages/event-report/List.vue')
    },
    {
        path: 'budget-allocation-report',
        name: prop + '.budget_allocation_report',
        meta: { auth: true },
        component: () => import('../pages/budget-allocation-report/List.vue')
    },
    {
        path: 'transportation-report',
        name: prop + '.transportation_report',
        meta: { auth: true },
        component: () => import('../pages/transportation-report/List.vue')
    },
    {
        path: 'requested-info-report',
        name: prop + '.requested_info_report',
        meta: { auth: true },
        component: () => import('../pages/requested-info-report/List.vue')
    },
    {
        path: 'assign-teacher-staff-report',
        name: prop + '.assign_teacher_staff_report',
        meta: { auth: true },
        component: () => import('../pages/assign-teacher-staff-report/List.vue')
    },
    {
        path: 'individual-assessment-report',
        name: prop + '.individual_assessment_report',
        meta: { auth: true },
        component: () => import('../pages/individual-assessment-report/List')
    },
    {
        path: 'curricular-wise-progress-report',
        name: prop + '.curricular_wise_progress_report',
        meta: { auth: true },
        component: () => import('../pages/curricular-wise-progress-report/List')
    },
    {
        path: 'teacher-training-report',
        name: prop + '.teacher_training_report',
        meta: { auth: true },
        component: () => import('../pages/teacher-training-report/List.vue')
    }
]
const routes = [{
    path: '/disability-school-service/report',
    name: 'disability_school_service.report',
    component: () => import('@/layouts/DisabilitySchoolLayout.vue'),
    meta: { auth: true },
    children: instituteManagementRoutes('disability_school_service.report')
}]
export default routes
